import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EMPTY, Observable } from 'rxjs'
import { publish, share } from 'rxjs/operators'
import { HttpOptionsFactory } from '../../../models/http/http-options-factory'
import { UrlCollection } from '../../../url-collection'
import { JmlMenuItem } from '../models/JmlMenuItem'

@Injectable({
  providedIn: 'root'
})
export class MenuConfigService {
  lastMenuRequestResult$: Observable<JmlMenuItem[]> = EMPTY
  constructor(private http: HttpClient) {}

  getMenuEntries(): Observable<JmlMenuItem[]> {
    const result$ = this.http
      .get<
        JmlMenuItem[]
      >(UrlCollection.Menu.ITEMS(), new HttpOptionsFactory().addAcceptJson().addContentTypeJson().build())
      .pipe(share())
    this.lastMenuRequestResult$ = result$
    return result$
  }
}
